import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { HotelFareModel } from '@src/shared/src/models';
import { AGGREGATORS } from '@src/shared/src/const/app';
import { formatCents } from '@src/shared/src/util/general';

type Props = {
  fare: HotelFareModel;
};

export const HotelFareBreakfastInfo: React.FC<Props> = ({ fare }) => {
  const { t } = useTranslation();
  const hasBreakfast = fare.breakfast;

  const getBreakfastInfo = (fare: HotelFareModel) => {
    if (fare.aggregator?.ident === AGGREGATORS.EXPEDIA_HOTEL && !fare.breakfast) {
      return t('hotelFare.tooltip.expedia.breakfastInfo');
    }

    if (fare.breakfastSurcharge && !fare.breakfast) {
      return t('hotelFare.tooltip.breakfastSurcharge', {
        breakfastSurcharge: formatCents(fare.breakfastSurcharge),
      });
    }
  };

  return (
    <span data-rh={getBreakfastInfo(fare)}>
      <i className={`material-symbols ${hasBreakfast ? 'is--green' : 'is--red'}`}>
        {hasBreakfast ? 'check_circle' : 'cancel'}
      </i>
      {hasBreakfast ? t('hotelFare.breakfast.included') : t('hotelFare.breakfast.notIncluded')}
    </span>
  );
};
